import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

import moment from 'moment';

import firebase from 'firebase/app';
require("firebase/firestore");

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

const styles = theme => ({
  textField: {
    width: 170,
  },
  marginRight: {
    marginRight: theme.spacing(2),
  },
})

class AdjustPassDialog extends Component {
  state = {
    open: this.props.open,
    processing: false,

    userPass: this.props.userPass,
  };

  getPassRecord = (passId) => {
    return this.props.userPass && this.props.userPass[passId];
  }

  handleSubmit = () => {
    if (this.props.customer && this.props.passes) {
      this.startProcessing();
      this.submitPassAmendment()
        .then(this.stopProcessing)
        .then(this.handleRequestClose);
    }
  }

  submitAdjustRecord = (records) => {
    records.userId = this.props.customer.id;
    records.adjustedBy = this.props.currentUser.id;
    records.datetime = new Date();

    return firebase.firestore()
      .collection('userPassAdjustRecords')
      .add(records);
  }

  submitPassAmendment = () => {
    var userPassRecordRef =  firebase.firestore().collection('userPasses');

    var pPassUpdates = [];
    var records = {};

    this.props.passes.filter(pass => pass.active).forEach(pass => {
      let passRecord = this.getPassRecord(pass.id);

      switch (pass.unit) {
        case 'time':
        case 'day': {
          let oldValue = passRecord && passRecord.remaining;
          let newValue = this.state[pass.id];
          
          if (isNumeric(newValue) && oldValue !== newValue) {
            if (passRecord && passRecord.id) {
              pPassUpdates.push(userPassRecordRef.doc(passRecord.id).update({
                remaining: newValue,
              }));

              records.userPassRecordId = passRecord.id;
              records[pass.id + "_before"] = oldValue;
            } else {
              pPassUpdates.push(userPassRecordRef.add({
                userId: this.props.customer.id,
                passId: pass.id,
                remaining: newValue,
              }));

              records.userPassRecordId = "new";
              records[pass.id + "_before"] = 0;
            }

            records[pass.id + "_after"] = newValue;
          }
          break;
        }
        case 'month': {
          let oldValue = passRecord && passRecord.expiryDate && passRecord.expiryDate.toDate();
          let newValue = this.state[pass.id] || null;

          if ((oldValue && oldValue.getTime()) !== (newValue && newValue.getTime())) {
            if (passRecord && passRecord.id) {
              pPassUpdates.push(userPassRecordRef.doc(passRecord.id).update({ 
                expiryDate: newValue,
              }));

              records.userPassRecordId = passRecord.id;
              records[pass.id + "_before"] = oldValue;
            } else {
              pPassUpdates.push(userPassRecordRef.add({
                userId: this.props.customer.id,
                passId: pass.id,
                expiryDate: newValue,
              }));

              records.userPassRecordId = "new";
              records[pass.id + "_before"] = null;
            }

            records[pass.id + "_after"] = newValue;
          }
          break;
        }
        default:
      }
    });

    return Promise.all(pPassUpdates, this.submitAdjustRecord(records));
  }

  startProcessing = () => {
    this.setState({ processing: true });
  }

  stopProcessing = () => {
    this.setState({ processing: false });
  }

  handleRequestClose = () => {
    this.setState({ open: false });
    this.props.onRequestClose();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      if (nextProps.open) {
        let state = {};
        state.open = nextProps.open;

        this.props.passes.forEach(pass => {
          state[pass.id] = nextProps.userPass &&
                           nextProps.userPass[pass.id] &&
                           (nextProps.userPass[pass.id].remaining || (nextProps.userPass[pass.id].expiryDate && nextProps.userPass[pass.id].expiryDate.toDate()));
        });

        this.setState(state);
      } else {
        this.setState({ open: nextProps.open, });
      }
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        onClose={this.handleRequestClose}
        open={this.state.open}>
        <DialogTitle>Passes Adjustment</DialogTitle>
        <DialogContent>
          <div>
            {/* Customer */}
            <Typography variant="h6" color="textSecondary">Customer</Typography>
            <div style={{ display: 'flex', flexWrap: 'wrap', }}>
              <TextField
                InputLabelProps={{ shrink: true, }}
                className={`${classes.textField} ${classes.marginRight}`}
                disabled
                label="Name"
                value={(this.props.customer && this.props.customer.name) || ''}
                margin="normal" />
              <TextField
                InputLabelProps={{ shrink: true, }}
                className={`${classes.textField} ${classes.marginRight}`}
                disabled
                label="Phone"
                value={(this.props.customer && this.props.customer.phone) || ''}
                margin="normal" />
              <TextField
                InputLabelProps={{ shrink: true, }}
                className={`${classes.textField}`}
                disabled
                label="Email"
                value={(this.props.customer && this.props.customer.email) || ''}
                margin="normal" />
            </div>
            <br/>
            {/* Passes */}
            <Typography variant="h6" color="textSecondary">Passes</Typography>
            { this.props.passes ?
              this.props.passes.filter(pass => pass.active).map((pass, index) => {
                switch (pass.unit) {
                  case 'time':
                  case 'day':
                    return (
                      <FormControl key={index} fullWidth margin="normal">
                        <InputLabel>{pass.name}</InputLabel>
                        <Input
                          value={ parseInt(this.state[pass.id], 10) || 0 }
                          onChange={ event => {
                            let state = {};
                            state[pass.id] = parseInt(event.target.value.replace(/\D/g,''), 10) || 0;
                            this.setState(state);
                          }}
                          disabled={
                            this.state.processing
                          }
                        />
                      </FormControl>
                    );
                  case 'month':
                    return (
                      <TextField
                        key={index}
                        fullWidth
                        margin="normal"
                        type="date"
                        InputLabelProps={{ shrink: true, }}
                        label={pass.name}
                        value={ this.state[pass.id] ? moment(this.state[pass.id]).format('YYYY-MM-DD') : "" }
                        onChange={ event => {
                          let state = {};
                          state[pass.id] = event.target.value ? moment(event.target.value, 'YYYY-MM-DD').toDate() : null;
                          this.setState(state);
                        }}
                        disabled={
                          this.state.processing
                        }
                      />
                    );
                  default:
                    return null;
                }
              })
              : null
            }

          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleRequestClose} >Close</Button>
          <Button
            disabled={this.state.processing}
            onClick={this.handleSubmit}
            color="primary">
            SUBMIT
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

AdjustPassDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  customer: PropTypes.object,
  passes: PropTypes.array.isRequired,
  userPass: PropTypes.object,
};

export default withStyles(styles)(AdjustPassDialog);
